module.exports = "build/assets/PensumPro-Book.90067938.woff2";